import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { findNodePosByLocalIds } from '@atlaskit/editor-common/utils';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { addAnalytics } from '../analytics/utils';
import { getPMFragmentWithFallback } from '../experience-application/get-pm-fragment-with-fallback';
import { getHasAcceptableUseWarning } from '../experience-application/screens-with-logic/utils/get-has-acceptable-use-warning';
import { createOpenAIModalCommand } from '../pm-plugins/decoration/actions';
import { findActionItemsConfigItem } from '../prebuilt/config-items-empty/find-action-items/find-action-items';
import { summarizePageConfigItem } from '../prebuilt/config-items-empty/summarize-page/summarize-page';
export var processStream = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(streaming, callback) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, streamItem, _ref2, _streamItem$data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 2;
          _iterator = _asyncIterator(streaming);
        case 4:
          _context.next = 6;
          return _iterator.next();
        case 6:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 27;
            break;
          }
          streamItem = _step.value;
          if (!(streamItem.state === 'failed')) {
            _context.next = 17;
            break;
          }
          if (!('reason' in streamItem)) {
            _context.next = 13;
            break;
          }
          if (!(streamItem.reason === 'rate-limited')) {
            _context.next = 13;
            break;
          }
          callback('RATE_LIMIT', streamItem.state);
          return _context.abrupt("continue", 24);
        case 13:
          callback((_ref2 = 'guard' in streamItem ? streamItem.guard : undefined) !== null && _ref2 !== void 0 ? _ref2 : 'API_FAILED', streamItem.state);
          return _context.abrupt("continue", 24);
        case 17:
          if (!(streamItem.state === 'aup-violation')) {
            _context.next = 22;
            break;
          }
          callback('ACCEPTABLE_USE_VIOLATIONS', streamItem.state);
          return _context.abrupt("continue", 24);
        case 22:
          callback((_streamItem$data = streamItem.data) === null || _streamItem$data === void 0 ? void 0 : _streamItem$data.content, streamItem.state);
          return _context.abrupt("continue", 24);
        case 24:
          _iteratorAbruptCompletion = false;
          _context.next = 4;
          break;
        case 27:
          _context.next = 33;
          break;
        case 29:
          _context.prev = 29;
          _context.t0 = _context["catch"](2);
          _didIteratorError = true;
          _iteratorError = _context.t0;
        case 33:
          _context.prev = 33;
          _context.prev = 34;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 38;
            break;
          }
          _context.next = 38;
          return _iterator.return();
        case 38:
          _context.prev = 38;
          if (!_didIteratorError) {
            _context.next = 41;
            break;
          }
          throw _iteratorError;
        case 41:
          return _context.finish(38);
        case 42:
          return _context.finish(33);
        case 43:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 29, 33, 43], [34,, 38, 42]]);
  }));
  return function processStream(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getAIPanelContext = function getAIPanelContext(_ref3) {
  var _configItem$getInitia;
  var configItem = _ref3.configItem,
    intentSchemaId = _ref3.intentSchemaId,
    editorView = _ref3.editorView,
    providerFactory = _ref3.providerFactory,
    idMap = _ref3.idMap,
    intl = _ref3.intl,
    updateIdMap = _ref3.updateIdMap;
  if (!editorView) {
    return;
  }
  var positions = [editorView.state.selection.$from.pos, editorView.state.selection.$to.pos];
  var initialContext = (_configItem$getInitia = configItem.getInitialContext) === null || _configItem$getInitia === void 0 ? void 0 : _configItem$getInitia.call(configItem, {
    editorView: editorView,
    positions: positions,
    intl: intl,
    updateIdMap: updateIdMap,
    intentSchemaId: intentSchemaId
  });
  return {
    schema: editorView.state.schema,
    providerFactory: providerFactory,
    idMap: idMap,
    initialContext: initialContext
  };
};
export var summarisePage = function summarisePage(_ref4) {
  var editorView = _ref4.editorView,
    generativeAIApiUrl = _ref4.generativeAIApiUrl,
    product = _ref4.product,
    callback = _ref4.callback,
    intl = _ref4.intl,
    initialContext = _ref4.initialContext,
    analyticsContext = _ref4.analyticsContext;
  if (!editorView) {
    return;
  }
  var promptRequest = summarizePageConfigItem.triggerPromptRequest({
    analyticsContext: analyticsContext,
    initialContext: initialContext !== null && initialContext !== void 0 ? initialContext : {
      userLocale: 'en',
      intentSchemaId: 'summarize_intent_schema.json',
      document: editorView.state.doc.toString()
    },
    editorSchema: editorView.state.schema,
    formatMessage: intl.formatMessage,
    streamingListener: callback
  });
  var streaming = promptRequest({
    generativeAIApiUrl: generativeAIApiUrl,
    product: product,
    abortController: new AbortController()
  });
  processStream(streaming, callback);
};
export var findActionItems = function findActionItems(_ref5) {
  var editorView = _ref5.editorView,
    generativeAIApiUrl = _ref5.generativeAIApiUrl,
    product = _ref5.product,
    callback = _ref5.callback,
    intl = _ref5.intl,
    initialContext = _ref5.initialContext,
    analyticsContext = _ref5.analyticsContext;
  if (!editorView) {
    return;
  }
  var promptRequest = findActionItemsConfigItem.triggerPromptRequest({
    analyticsContext: analyticsContext,
    initialContext: initialContext !== null && initialContext !== void 0 ? initialContext : {
      userLocale: 'en',
      intentSchemaId: 'action_items_intent_schema.json',
      document: editorView.state.doc.toString()
    },
    editorSchema: editorView.state.schema,
    formatMessage: intl.formatMessage,
    streamingListener: callback
  });
  var streaming = promptRequest({
    generativeAIApiUrl: generativeAIApiUrl,
    product: product,
    abortController: new AbortController()
  });
  processStream(streaming, callback);
};
export var regenerateExtension = function regenerateExtension(_ref6) {
  var api = _ref6.api,
    editorView = _ref6.editorView,
    localId = _ref6.localId,
    extensionKey = _ref6.extensionKey,
    idMap = _ref6.idMap;
  var tr = editorView === null || editorView === void 0 ? void 0 : editorView.state.tr;
  if (editorView && tr) {
    addAnalytics({
      editorState: editorView === null || editorView === void 0 ? void 0 : editorView.state,
      tr: tr,
      payload: {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'AIPanels',
        eventType: EVENT_TYPE.UI,
        attributes: {
          extensionType: 'com.atlassian.ai-blocks',
          extensionKey: extensionKey,
          action: 'regenerate'
        }
      }
    });
  }
  convertExtension({
    api: api,
    editorView: editorView,
    localId: localId,
    extensionKey: extensionKey,
    idMap: idMap,
    tr: tr
  });
};
export var convertExtension = function convertExtension(_ref7) {
  var api = _ref7.api,
    editorView = _ref7.editorView,
    localId = _ref7.localId,
    extensionKey = _ref7.extensionKey,
    idMap = _ref7.idMap,
    tr = _ref7.tr,
    addToHistory = _ref7.addToHistory;
  if (!editorView) {
    return;
  }
  var nodes = findNodePosByLocalIds(editorView.state, [localId]);
  if (!tr) {
    tr = editorView.state.tr;
  }
  var nodeToReplace = nodes[0];
  if (!nodeToReplace) {
    return;
  }
  var _getPMFragmentWithFal = getPMFragmentWithFallback({
      markdown: nodeToReplace.node.attrs.parameters.content,
      schema: editorView.state.schema,
      source: 'ai-blocks',
      fireAIAnalyticsEvent: function fireAIAnalyticsEvent() {},
      idMap: idMap
    }),
    pmFragment = _getPMFragmentWithFal.pmFragment;
  if (extensionKey.includes('BodiedExtension')) {
    var _api$extension;
    tr = api === null || api === void 0 || (_api$extension = api.extension) === null || _api$extension === void 0 ? void 0 : _api$extension.actions.insertOrReplaceBodiedExtension({
      editorView: editorView,
      action: 'replace',
      attrs: _objectSpread(_objectSpread({}, nodeToReplace.node.attrs), {}, {
        extensionType: 'com.atlassian.ai-blocks',
        extensionKey: extensionKey
      }),
      content: pmFragment,
      position: nodeToReplace.pos,
      size: nodeToReplace.node.nodeSize,
      tr: tr
    });
    if (typeof addToHistory === 'boolean') {
      tr.setMeta('addToHistory', addToHistory);
    }
    editorView.dispatch(tr);
  } else {
    var _api$extension2;
    // We want to delete the original node first and then create the new node and insert it
    // This way if we call regenerate whilst on the extension view, the state will be updated correctly
    // and retrigger the regenerate
    var _tr = editorView.state.tr.delete(nodeToReplace.pos, nodeToReplace.pos + nodeToReplace.node.nodeSize);
    if (typeof addToHistory === 'boolean') {
      _tr.setMeta('addToHistory', addToHistory);
    }
    editorView.dispatch(_tr);
    _tr = api === null || api === void 0 || (_api$extension2 = api.extension) === null || _api$extension2 === void 0 ? void 0 : _api$extension2.actions.insertOrReplaceExtension({
      editorView: editorView,
      action: 'insert',
      attrs: _objectSpread(_objectSpread({}, nodeToReplace.node.attrs), {}, {
        extensionType: 'com.atlassian.ai-blocks',
        extensionKey: extensionKey,
        parameters: _objectSpread(_objectSpread({}, nodeToReplace.node.attrs.parameters), {}, {
          content: ''
        })
      }),
      content: Fragment.from([]),
      position: nodeToReplace.pos,
      size: nodeToReplace.node.nodeSize,
      tr: _tr
    });
    editorView.dispatch(_tr);
    if (typeof addToHistory === 'boolean') {
      _tr.setMeta('addToHistory', addToHistory);
    }
    editorView.dispatch(_tr);
  }
};
var trackAnalyticsEvent = function trackAnalyticsEvent(fireAnalyticsEvent, product, extensionKey, productSuccessStatus, hasAcceptableUseWarning) {
  var payload = {
    action: 'click',
    actionSubject: 'editorPluginAI',
    actionSubjectId: 'AIPanelsFeedbackButton',
    attributes: {
      extensionKey: extensionKey,
      sentiment: 'unknown',
      hasAcceptableUseWarning: hasAcceptableUseWarning,
      appearance: 'unknown',
      product: product,
      productSuccessStatus: productSuccessStatus
    },
    eventType: EVENT_TYPE.UI
  };

  // @ts-ignore
  fireAnalyticsEvent(payload);
};
export var triggerAIPanelFeedbackCollector = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref8) {
    var extensionKey, markdown, locale, editorPluginAIProvider, fireAnalyticsEvent, hasAcceptableUseWarning, _editorPluginAIProvid, productResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          extensionKey = _ref8.extensionKey, markdown = _ref8.markdown, locale = _ref8.locale, editorPluginAIProvider = _ref8.editorPluginAIProvider, fireAnalyticsEvent = _ref8.fireAnalyticsEvent;
          hasAcceptableUseWarning = getHasAcceptableUseWarning({
            markdown: markdown,
            locale: locale
          });
          if (!(!editorPluginAIProvider || !fireAnalyticsEvent)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (_editorPluginAIProvid = editorPluginAIProvider.handleFeedbackSubmission) === null || _editorPluginAIProvid === void 0 ? void 0 : _editorPluginAIProvid.call(editorPluginAIProvider, {
            sentiment: 'unknown',
            getAIExperience: function getAIExperience(hasUserConsent) {
              return _objectSpread({
                hasAcceptableUseWarning: hasAcceptableUseWarning,
                extensionKey: extensionKey
              }, hasUserConsent ? {
                markdownResponse: markdown
              } : {});
            },
            editorAttributes: {
              appearance: 'unknown',
              product: editorPluginAIProvider.product
            }
          });
        case 7:
          productResponse = _context2.sent;
          trackAnalyticsEvent(fireAnalyticsEvent, editorPluginAIProvider.product, extensionKey, productResponse === null || productResponse === void 0 ? void 0 : productResponse.status, hasAcceptableUseWarning);
          _context2.next = 14;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](4);
          trackAnalyticsEvent(fireAnalyticsEvent, editorPluginAIProvider.product, extensionKey, 'failed', hasAcceptableUseWarning);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 11]]);
  }));
  return function triggerAIPanelFeedbackCollector(_x3) {
    return _ref9.apply(this, arguments);
  };
}();
export var openAIModal = function openAIModal(_ref10) {
  var invokedFrom = _ref10.invokedFrom,
    aiOptIn = _ref10.aiOptIn,
    configItem = _ref10.configItem,
    editorView = _ref10.editorView;
  if (!editorView) {
    return;
  }
  var openAIModalCommand = createOpenAIModalCommand({
    state: editorView.state,
    configItem: configItem,
    lastTriggeredFrom: invokedFrom,
    aiGlobalOptIn: aiOptIn
  });
  openAIModalCommand(editorView.state, editorView.dispatch);
};